export const getDateAndMonth = (timestampForDateLabel) =>{
    const date = new Date(timestampForDateLabel);
  
    const day = date.getDate(); // Get the day of the month
    const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const month = monthNames[date.getMonth()]; // Get the month name from the array
  
    return `${day} ${month}`;
}